import { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { apiClient } from 'core/http'
import socketClient from 'core/socket/socketClient'
import { MilestoneItem } from './item'
import c from './assets/sass/milestones.module.scss'

const DEFAULT_MILESTONES = [
    { threshold: 3, reward: 'case', coinAmount: 0 },
    { threshold: 5, reward: 'coins', coinAmount: 1000 },
    { threshold: 7, reward: 'case', coinAmount: 0 },
    { threshold: 9, reward: 'coins', coinAmount: 1500 },
    { threshold: 12, reward: 'case', coinAmount: 0 },
    { threshold: 15, reward: 'case', coinAmount: 0 },
    { threshold: 18, reward: 'coins', coinAmount: 2500 },
    { threshold: 22, reward: 'case', coinAmount: 0 },
    { threshold: 25, reward: 'case', coinAmount: 0 },
    { threshold: 30, reward: 'coins', coinAmount: 5000 },
    { threshold: 40, reward: 'case', coinAmount: 0 },
    { threshold: 50, reward: 'coins', coinAmount: 5000 },
    { threshold: 60, reward: 'case', coinAmount: 0 },
    { threshold: 70, reward: 'coins', coinAmount: 5000 },
    { threshold: 80, reward: 'case', coinAmount: 0 },
    { threshold: 90, reward: 'coins', coinAmount: 5000 },
    { threshold: 100, reward: 'case', coinAmount: 0 },
]

export const Milestones = ({ totalFriends = 0 }) => {
    const { t } = useTranslation()
    const [milestones, setMilestones] = useState(DEFAULT_MILESTONES)
    const [claimedThresholds, setClaimedThresholds] = useState([])

    const fetchMilestones = useCallback(async () => {
        try {
            const res = await apiClient.get('/friends/milestones')
            if (res?.data?.success && Array.isArray(res.data.milestones)) {
                setMilestones(res.data.milestones)
            }
            if (Array.isArray(res?.data?.claimed)) {
                setClaimedThresholds(res.data.claimed)
            }
        } catch (e) {}
    }, [])

    useEffect(() => {
        fetchMilestones()
        const handler = () => fetchMilestones()
        socketClient.on('referral_added', handler)
        return () => socketClient.off('referral_added', handler)
    }, [fetchMilestones])

    const reachedFlags = milestones.map((m) => totalFriends >= m.threshold)
    const highestIdx = reachedFlags.lastIndexOf(true)
    const goldPct = highestIdx >= 0
        ? ((highestIdx + 0.5) / milestones.length) * 100
        : 0

    return (
        <div className={c.component}>
            <div className={c.header}>
                <div className={c.headerTab}>{t('earnings.milestones.friendsCount')}</div>
                <div />
                <div className={c.headerTab}>{t('earnings.milestones.rewards')}</div>
            </div>
            <div className={c.timeline}>
                <div className={c.rail}>
                    <div className={c.railBg} />
                    <div className={c.railFill} style={{ height: `${goldPct}%` }} />
                </div>
                {milestones.map((m, i) => {
                    const isClaimed = claimedThresholds.includes(m.threshold)
                    const isAvailable = totalFriends >= m.threshold && !isClaimed
                    const isLocked = totalFriends < m.threshold

                    return (
                        <MilestoneItem
                            key={m.threshold}
                            threshold={m.threshold}
                            rewardType={m.reward}
                            coinAmount={m.coinAmount}
                            caseImage={m.caseImage}
                            caseName={m.caseName}
                            isClaimed={isClaimed}
                            isAvailable={isAvailable}
                            isLocked={isLocked}
                            isFirst={i === 0}
                            isLast={i === milestones.length - 1}
                            onClaimed={fetchMilestones}
                        />
                    )
                })}
            </div>
        </div>
    )
}
